export const phoneRegex = /^\+*(\d|\s)+$/
export const numberRegex = /^\d*$/
